export var messageReducer = (state = {errors: [], successes: [], warnings: [], info: [], nextSuccesses: []}, action) => {
	var isFound = false;

	switch(action.type) {
		case "RAISE_ERROR": 
			var errors = state.errors;
			isFound = errors.filter(s => s === action.error).length > 0;
			if (!isFound) {
				errors.push(action.error);
				return {...state, errors};	
			}
			return state;
		case "RAISE_WARNING":
			var warnings = state.warnings;
			isFound = warnings.filter(s => s === action.warning).length > 0;
			if (!isFound) {
				warnings.push(action.warning);
				return {...state, warnings};	
			}
			return state;
		case "RAISE_INFO":
			var info = state.info;
			isFound = info.filter(s => s === action.info).length > 0;
			if (!isFound) {
				info.push(action.info);
				return {...state, info};
			}
			return state;
		case "RAISE_SUCCESS":
			var successes = state.successes;
			isFound = successes.filter(s => s === action.success).length > 0;
			if (!isFound) {
				successes.push(action.success);
				return {...state, successes};	
			}
			return state;
		case "RAISE_NEXT_SUCCESS":
			var nextSuccesses = state.nextSuccesses;
			isFound = nextSuccesses.filter(s => s === action.success).length > 0;
			if (!isFound) {
				nextSuccesses.push(action.success);
				return {...state, nextSuccesses};	
			}
			return state;
		case "SHOW_NEXT":
			successes = state.nextSuccesses;
			return {...state, successes, nextSuccesses:[]};
		case "RESET_MESSAGES":
			return {...state, errors: [], successes: [], warnings: []};
		case "RESET_ERRORS":
			return {...state, errors: [], warnings: []};
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/messageReducer.js